/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ReverseTpnAliases {
  APPLY_FILTER_BUTTON = 'apply-filter-button',
  AUTOCOMPLETE = 'autocomplete',
  AUTOCOMPLETE_REASON_LIST = 'autocomplete-reason-list',
  CLEAR_FILTER_BUTTON = 'clear-filter-button',
  CONTEXTUAL_BAR = 'contextual-bar',
  CONTEXTUAL_BAR_REVERSE_TPN = 'contextual-bar-reverse-tpn',
  DATE_FIELD = 'date-field',
  DATE_INPUT = 'date-input',
  FETCH = 'fetch',
  FETCH_REASON = 'fetch-reason',
  FIELD = 'field',
  FIELD_REASON = 'field-reason',
  FILTER = 'filter',
  FILTERED_LIST = 'filtered-list',
  FORM_REASON = 'form-reason',
  FRAGMENT_INFORMATION_BAR_HEADER = 'fragment-information-bar-header',
  HEADER_FRAGMENT_REVERSE_TPN = 'header-fragment-reverse-tpn',
  LOADER = 'loader',
  MAPPER = 'mapper',
  MAPPER_REVERSE = 'mapper-reverse',
  NOTES_FIELD = 'notes-field',
  NOTES_TEXT_AREA = 'notes-text-area',
  PANEL_BUTTON_APPLY = 'panel-button-apply',
  PANEL_BUTTON_CLEAR = 'panel-button-clear',
  PANEL_BUTTONS = 'panel-buttons',
  PANEL_LOADER = 'panel-loader',
  PANEL_REVERSE_TPN = 'panel-reverse-tpn',
  REVERSE_TPN_LAYOUT = 'reverse-tpn-layout',
  TEXT = 'text',
  TEXT_REVERSE = 'text-reverse',
}
export { ReverseTpnAliases };
